// extracted by mini-css-extract-plugin
export default {"pickerWrap":"DateRangePicker_pickerWrap__3vvgR","shortcuts":"DateRangePicker_shortcuts__4Cscs","darkText":"DateRangePicker_darkText__4Obl9"};